// Got errors when initially tried to import the urls directly from env, but importing urls from here worked.
// Perhaps it was due to having envs missing in getVaultKeys (or maybe webpack.common was missing something)
// Either way, I've already tested it this way and don't want to try to change everything again right now hehe.

const routeTheGrapefulClub = 'preferred';
const urlTrinityBackoffice =
  process.env.TRINITY_BACKOFFICE_URL || 'http://12.235.159.82';
const urlProductCatalogPage =
  process.env.NODE_ENV !== 'development'
    ? `${process.env.HOPECOMMERCE_URL}/shop`
    : 'http://localhost:4005';
const urlTastingFlightLandingPage =
  process.env.NODE_ENV !== 'development'
    ? `${process.env.HOPECOMMERCE_URL}/tasting-flight`
    : 'http://localhost:4007/tasting-flight';

const urlBecomeCauseEntrepreneur = `https://go.onehopewine.com/thank-you-for-your-interest-in-becoming-a-cause-entrepreneur`;
const urlCeEnrollment =
  process.env.CE_ENROLLMENT_URL || 'http://localhost:4002';
const urlHopecommerce = process.env.HOPECOMMERCE_URL || 'http://localhost:3000';
const urlCheckout = process.env.CHECKOUT_URL || 'http://localhost:4001';

const urlCeDash = process.env.CE_DASHBOARD_URL || 'http://localhost:4000';
const urlCeEvents = `${urlCeDash}/events`;
const urlCeHome = `${urlCeDash}/dashboard`;
const urlCeCustomers = `${urlCeDash}/customers`;
const urlCeOrders = `${urlCeDash}/customer-orders`;

module.exports = {
  routeTheGrapefulClub,
  urlBecomeCauseEntrepreneur,
  urlTrinityBackoffice,
  urlProductCatalogPage,
  urlTastingFlightLandingPage,
  urlCeEnrollment,
  urlHopecommerce,
  urlCheckout,
  urlCeDash,
  urlCeEvents,
  urlCeHome,
  urlCeCustomers,
  urlCeOrders,
};
